export default "__VITE_ASSET__DZL9wAqN__"